"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timeZones = void 0;
var timeZones;
(function (timeZones) {
    timeZones["ASIA_JERUSALEM"] = "Asia/Jerusalem";
    timeZones["EUROPE_LONDON"] = "Europe/London";
    timeZones["AMERICA_NEW_YORK"] = "America/New_York";
    timeZones["AMERICA_DENVER"] = "America/Denver";
    timeZones["AMERICA_ANCHORAGE"] = "America/Anchorage";
    timeZones["AMERICA_PHOENIX"] = "America/Phoenix";
    timeZones["AMERICA_CHICAGO"] = "America/Chicago";
    timeZones["AMERICA_LOS_ANGELES"] = "America/Los_Angeles";
    timeZones["PACIFIC_HONOLULU"] = "Pacific/Honolulu";
    timeZones["AMERICA_BOISE"] = "America/Boise";
    timeZones["AMERICA_INDIANAPOLIS"] = "America/Indianapolis";
    timeZones["AMERICA_DETROIT"] = "America/Detroit";
    timeZones["AMERIC_SANTO_DOMINGO"] = "America/Santo_Domingo";
    timeZones["UTC"] = "Etc/UTC";
})(timeZones || (exports.timeZones = timeZones = {}));
